import type { ExecutionScope, TaskStatus } from '../core/contracts/index.js';

export interface AuditRecord {
  id: string;
  taskId: string;
  agentId: string;
  scope: ExecutionScope;
  status: TaskStatus;
  event: string;
  timestamp: number;
  signature?: string;
}

export class AuditLogger {
  private records: AuditRecord[] = [];

  log(record: Omit<AuditRecord, 'id' | 'timestamp'>): AuditRecord {
    const fullRecord: AuditRecord = {
      ...record,
      id: `audit-${Date.now()}-${Math.random().toString(36).substring(2, 7)}`,
      timestamp: Date.now(),
    };
    this.records.push(fullRecord);
    return fullRecord;
  }

  getTaskHistory(taskId: string): AuditRecord[] {
    return this.records.filter((r) => r.taskId === taskId);
  }

  getTenantAuditTrail(tenantId: string): AuditRecord[] {
    return this.records.filter((r) => r.scope.tenantId === tenantId);
  }
}
